(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["flag~index"],{

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _style_index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(275);
/* harmony import */ var _style_index_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_style_index_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
// 样式文件


var component = {
  name: 'MegFlag',
  props: {
    position: utils__WEBPACK_IMPORTED_MODULE_1__[/* vueTypes */ "d"].oneOf(['leftTop', 'rightTop', 'leftBottom', 'rightBottom']).def('leftTop'),
    label: {
      type: String,
      default: ''
    },
    labelBg: {
      type: String,
      default: '#1067D1'
    },
    labelTrigleBg: {
      type: String,
      default: '#0567a1'
    }
  },
  computed: {
    borderColor: function borderColor() {
      var labelTrigleBg = this.labelTrigleBg;
      return "".concat(labelTrigleBg, " ").concat(labelTrigleBg, " transparent transparent");
    },
    classes: function classes() {
      var position = this.position.replace(/([A-Z])/g, "-$1").toLowerCase();
      return "meg-flag-label-".concat(position);
    }
  },
  mounted: function mounted() {},
  beforeCreate: function beforeCreate() {},
  methods: {
    click: function click() {},
    mouseOver: function mouseOver() {}
  },
  render: function render() {
    var h = arguments[0];
    var borderColor = this.borderColor,
        labelBg = this.labelBg;
    var label = this.label && h("div", {
      "class": ["meg-flag-label", this.classes],
      style: {
        backgroundColor: labelBg
      }
    }, [this.label, h("div", {
      "class": "meg-flag-label-trigle",
      style: {
        borderColor: borderColor
      }
    })]);
    return h("div", {
      "class": 'meg-flag',
      on: {
        "click": this.click,
        "mouseover": this.mouseOver
      }
    }, [this.$slots.default, label]);
  }
};

component.install = function (Vue) {
  Vue.component(component.name, component);
};

/* harmony default export */ __webpack_exports__["default"] = (component);

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

}]);